import { Box, SimpleGrid} from "@chakra-ui/react";
import AdminListTable from "./components/AdminListTable";

const AdminList = () => 
{

    return (                         

        <Box pt={{ base: "5px", md: "5px", xl: "5px" }}>


            <SimpleGrid>
                <AdminListTable/>
            </SimpleGrid>
        </Box>       
    );

};
  
export default AdminList;
